import { useMemo } from 'react';

export const ALL_COUNTRIES = [
  { name: 'Afghanistan', code: 'AF', nameKey: 'allCountries.AF' },
  { name: 'Åland Islands', code: 'AX', nameKey: 'allCountries.AX' },
  { name: 'Albania', code: 'AL', nameKey: 'allCountries.AL' },
  { name: 'Algeria', code: 'DZ', nameKey: 'allCountries.DZ' },
  { name: 'American Samoa', code: 'AS', nameKey: 'allCountries.AS' },
  { name: 'AndorrA', code: 'AD', nameKey: 'allCountries.AD' },
  { name: 'Angola', code: 'AO', nameKey: 'allCountries.AO' },
  { name: 'Anguilla', code: 'AI', nameKey: 'allCountries.AI' },
  { name: 'Antarctica', code: 'AQ', nameKey: 'allCountries.AQ' },
  { name: 'Antigua and Barbuda', code: 'AG', nameKey: 'allCountries.AG' },
  { name: 'Argentina', code: 'AR', nameKey: 'allCountries.AR' },
  { name: 'Armenia', code: 'AM', nameKey: 'allCountries.AM' },
  { name: 'Aruba', code: 'AW', nameKey: 'allCountries.AW' },
  { name: 'Australia', code: 'AU', nameKey: 'allCountries.AU' },
  { name: 'Austria', code: 'AT', nameKey: 'allCountries.AT' },
  { name: 'Azerbaijan', code: 'AZ', nameKey: 'allCountries.AZ' },
  { name: 'Bahamas', code: 'BS', nameKey: 'allCountries.BS' },
  { name: 'Bahrain', code: 'BH', nameKey: 'allCountries.BH' },
  { name: 'Bangladesh', code: 'BD', nameKey: 'allCountries.BD' },
  { name: 'Barbados', code: 'BB', nameKey: 'allCountries.BB' },
  { name: 'Belarus', code: 'BY', nameKey: 'allCountries.BY' },
  { name: 'Belgium', code: 'BE', nameKey: 'allCountries.BE' },
  { name: 'Belize', code: 'BZ', nameKey: 'allCountries.BZ' },
  { name: 'Benin', code: 'BJ', nameKey: 'allCountries.BJ' },
  { name: 'Bermuda', code: 'BM', nameKey: 'allCountries.BM' },
  { name: 'Bhutan', code: 'BT', nameKey: 'allCountries.BT' },
  { name: 'Bolivia', code: 'BO', nameKey: 'allCountries.BO' },
  { name: 'Bosnia and Herzegovina', code: 'BA', nameKey: 'allCountries.BA' },
  { name: 'Botswana', code: 'BW', nameKey: 'allCountries.BW' },
  { name: 'Bouvet Island', code: 'BV', nameKey: 'allCountries.BV' },
  { name: 'Brazil', code: 'BR', nameKey: 'allCountries.BR' },
  { name: 'British Indian Ocean Territory', code: 'IO', nameKey: 'allCountries.IO' },
  { name: 'Brunei Darussalam', code: 'BN', nameKey: 'allCountries.BN' },
  { name: 'Bulgaria', code: 'BG', nameKey: 'allCountries.BG' },
  { name: 'Burkina Faso', code: 'BF', nameKey: 'allCountries.BF' },
  { name: 'Burundi', code: 'BI', nameKey: 'allCountries.BI' },
  { name: 'Cambodia', code: 'KH', nameKey: 'allCountries.KH' },
  { name: 'Cameroon', code: 'CM', nameKey: 'allCountries.CM' },
  { name: 'Canada', code: 'CA', nameKey: 'allCountries.CA' },
  { name: 'Cape Verde', code: 'CV', nameKey: 'allCountries.CV' },
  { name: 'Cayman Islands', code: 'KY', nameKey: 'allCountries.KY' },
  { name: 'Central African Republic', code: 'CF', nameKey: 'allCountries.CF' },
  { name: 'Chad', code: 'TD', nameKey: 'allCountries.TD' },
  { name: 'Chile', code: 'CL', nameKey: 'allCountries.CL' },
  { name: 'China', code: 'CN', nameKey: 'allCountries.CN' },
  { name: 'Christmas Island', code: 'CX', nameKey: 'allCountries.CX' },
  { name: 'Cocos (Keeling) Islands', code: 'CC', nameKey: 'allCountries.CC' },
  { name: 'Colombia', code: 'CO', nameKey: 'allCountries.CO' },
  { name: 'Comoros', code: 'KM', nameKey: 'allCountries.KM' },
  { name: 'Congo', code: 'CG', nameKey: 'allCountries.CG' },
  { name: 'Congo, The Democratic Republic of the', code: 'CD', nameKey: 'allCountries.CD' },
  { name: 'Cook Islands', code: 'CK', nameKey: 'allCountries.CK' },
  { name: 'Costa Rica', code: 'CR', nameKey: 'allCountries.CR' },
  { name: "Cote D'Ivoire", code: 'CI', nameKey: 'allCountries.CI' },
  { name: 'Croatia', code: 'HR', nameKey: 'allCountries.HR' },
  { name: 'Cuba', code: 'CU', nameKey: 'allCountries.CU' },
  { name: 'Cyprus', code: 'CY', nameKey: 'allCountries.CY' },
  { name: 'Czech Republic', code: 'CZ', nameKey: 'allCountries.CZ' },
  { name: 'Denmark', code: 'DK', nameKey: 'allCountries.DK' },
  { name: 'Djibouti', code: 'DJ', nameKey: 'allCountries.DJ' },
  { name: 'Dominica', code: 'DM', nameKey: 'allCountries.DM' },
  { name: 'Dominican Republic', code: 'DO', nameKey: 'allCountries.DO' },
  { name: 'Ecuador', code: 'EC', nameKey: 'allCountries.EC' },
  { name: 'Egypt', code: 'EG', nameKey: 'allCountries.EG' },
  { name: 'El Salvador', code: 'SV', nameKey: 'allCountries.SV' },
  { name: 'Equatorial Guinea', code: 'GQ', nameKey: 'allCountries.GQ' },
  { name: 'Eritrea', code: 'ER', nameKey: 'allCountries.ER' },
  { name: 'Estonia', code: 'EE', nameKey: 'allCountries.EE' },
  { name: 'Ethiopia', code: 'ET', nameKey: 'allCountries.ET' },
  { name: 'Falkland Islands (Malvinas)', code: 'FK', nameKey: 'allCountries.FK' },
  { name: 'Faroe Islands', code: 'FO', nameKey: 'allCountries.FO' },
  { name: 'Fiji', code: 'FJ', nameKey: 'allCountries.FJ' },
  { name: 'Finland', code: 'FI', nameKey: 'allCountries.FI' },
  { name: 'France', code: 'FR', nameKey: 'allCountries.FR' },
  { name: 'French Guiana', code: 'GF', nameKey: 'allCountries.GF' },
  { name: 'French Polynesia', code: 'PF', nameKey: 'allCountries.PF' },
  { name: 'French Southern Territories', code: 'TF', nameKey: 'allCountries.TF' },
  { name: 'Gabon', code: 'GA', nameKey: 'allCountries.GA' },
  { name: 'Gambia', code: 'GM', nameKey: 'allCountries.GM' },
  { name: 'Georgia', code: 'GE', nameKey: 'allCountries.GE' },
  { name: 'Germany', code: 'DE', nameKey: 'allCountries.DE' },
  { name: 'Ghana', code: 'GH', nameKey: 'allCountries.GH' },
  { name: 'Gibraltar', code: 'GI', nameKey: 'allCountries.GI' },
  { name: 'Greece', code: 'GR', nameKey: 'allCountries.GR' },
  { name: 'Greenland', code: 'GL', nameKey: 'allCountries.GL' },
  { name: 'Grenada', code: 'GD', nameKey: 'allCountries.GD' },
  { name: 'Guadeloupe', code: 'GP', nameKey: 'allCountries.GP' },
  { name: 'Guam', code: 'GU', nameKey: 'allCountries.GU' },
  { name: 'Guatemala', code: 'GT', nameKey: 'allCountries.GT' },
  { name: 'Guernsey', code: 'GG', nameKey: 'allCountries.GG' },
  { name: 'Guinea', code: 'GN', nameKey: 'allCountries.GN' },
  { name: 'Guinea-Bissau', code: 'GW', nameKey: 'allCountries.GW' },
  { name: 'Guyana', code: 'GY', nameKey: 'allCountries.GY' },
  { name: 'Haiti', code: 'HT', nameKey: 'allCountries.HT' },
  { name: 'Heard Island and Mcdonald Islands', code: 'HM', nameKey: 'allCountries.HM' },
  { name: 'Holy See (Vatican City State)', code: 'VA', nameKey: 'allCountries.VA' },
  { name: 'Honduras', code: 'HN', nameKey: 'allCountries.HN' },
  { name: 'Hong Kong', code: 'HK', nameKey: 'allCountries.HK' },
  { name: 'Hungary', code: 'HU', nameKey: 'allCountries.HU' },
  { name: 'Iceland', code: 'IS', nameKey: 'allCountries.IS' },
  { name: 'India', code: 'IN', nameKey: 'allCountries.IN' },
  { name: 'Indonesia', code: 'ID', nameKey: 'allCountries.ID' },
  { name: 'Iran, Islamic Republic Of', code: 'IR', nameKey: 'allCountries.IR' },
  { name: 'Iraq', code: 'IQ', nameKey: 'allCountries.IQ' },
  { name: 'Ireland', code: 'IE', nameKey: 'allCountries.IE' },
  { name: 'Isle of Man', code: 'IM', nameKey: 'allCountries.IM' },
  { name: 'Israel', code: 'IL', nameKey: 'allCountries.IL' },
  { name: 'Italy', code: 'IT', nameKey: 'allCountries.IT' },
  { name: 'Jamaica', code: 'JM', nameKey: 'allCountries.JM' },
  { name: 'Japan', code: 'JP', nameKey: 'allCountries.JP' },
  { name: 'Jersey', code: 'JE', nameKey: 'allCountries.JE' },
  { name: 'Jordan', code: 'JO', nameKey: 'allCountries.JO' },
  { name: 'Kazakhstan', code: 'KZ', nameKey: 'allCountries.KZ' },
  { name: 'Kenya', code: 'KE', nameKey: 'allCountries.KE' },
  { name: 'Kiribati', code: 'KI', nameKey: 'allCountries.KI' },
  { name: "Korea, Democratic People'S Republic of", code: 'KP', nameKey: 'allCountries.KP' },
  { name: 'Korea, Republic of', code: 'KR', nameKey: 'allCountries.KR' },
  { name: 'Kuwait', code: 'KW', nameKey: 'allCountries.KW' },
  { name: 'Kyrgyzstan', code: 'KG', nameKey: 'allCountries.KG' },
  { name: "Lao People'S Democratic Republic", code: 'LA', nameKey: 'allCountries.LA' },
  { name: 'Latvia', code: 'LV', nameKey: 'allCountries.LV' },
  { name: 'Lebanon', code: 'LB', nameKey: 'allCountries.LB' },
  { name: 'Lesotho', code: 'LS', nameKey: 'allCountries.LS' },
  { name: 'Liberia', code: 'LR', nameKey: 'allCountries.LR' },
  { name: 'Libyan Arab Jamahiriya', code: 'LY', nameKey: 'allCountries.LY' },
  { name: 'Liechtenstein', code: 'LI', nameKey: 'allCountries.LI' },
  { name: 'Lithuania', code: 'LT', nameKey: 'allCountries.LT' },
  { name: 'Luxembourg', code: 'LU', nameKey: 'allCountries.LU' },
  { name: 'Macao', code: 'MO', nameKey: 'allCountries.MO' },
  { name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK', nameKey: 'allCountries.MK' },
  { name: 'Madagascar', code: 'MG', nameKey: 'allCountries.MG' },
  { name: 'Malawi', code: 'MW', nameKey: 'allCountries.MW' },
  { name: 'Malaysia', code: 'MY', nameKey: 'allCountries.MY' },
  { name: 'Maldives', code: 'MV', nameKey: 'allCountries.MV' },
  { name: 'Mali', code: 'ML', nameKey: 'allCountries.ML' },
  { name: 'Malta', code: 'MT', nameKey: 'allCountries.MT' },
  { name: 'Marshall Islands', code: 'MH', nameKey: 'allCountries.MH' },
  { name: 'Martinique', code: 'MQ', nameKey: 'allCountries.MQ' },
  { name: 'Mauritania', code: 'MR', nameKey: 'allCountries.MR' },
  { name: 'Mauritius', code: 'MU', nameKey: 'allCountries.MU' },
  { name: 'Mayotte', code: 'YT', nameKey: 'allCountries.YT' },
  { name: 'Mexico', code: 'MX', nameKey: 'allCountries.MX' },
  { name: 'Micronesia, Federated States of', code: 'FM', nameKey: 'allCountries.FM' },
  { name: 'Moldova, Republic of', code: 'MD', nameKey: 'allCountries.MD' },
  { name: 'Monaco', code: 'MC', nameKey: 'allCountries.MC' },
  { name: 'Mongolia', code: 'MN', nameKey: 'allCountries.MN' },
  { name: 'Montserrat', code: 'MS', nameKey: 'allCountries.MS' },
  { name: 'Morocco', code: 'MA', nameKey: 'allCountries.MA' },
  { name: 'Mozambique', code: 'MZ', nameKey: 'allCountries.MZ' },
  { name: 'Myanmar', code: 'MM', nameKey: 'allCountries.MM' },
  { name: 'Namibia', code: 'NA', nameKey: 'allCountries.NA' },
  { name: 'Nauru', code: 'NR', nameKey: 'allCountries.NR' },
  { name: 'Nepal', code: 'NP', nameKey: 'allCountries.NP' },
  { name: 'Netherlands', code: 'NL', nameKey: 'allCountries.NL' },
  { name: 'Netherlands Antilles', code: 'AN', nameKey: 'allCountries.AN' },
  { name: 'New Caledonia', code: 'NC', nameKey: 'allCountries.NC' },
  { name: 'New Zealand', code: 'NZ', nameKey: 'allCountries.NZ' },
  { name: 'Nicaragua', code: 'NI', nameKey: 'allCountries.NI' },
  { name: 'Niger', code: 'NE', nameKey: 'allCountries.NE' },
  { name: 'Nigeria', code: 'NG', nameKey: 'allCountries.NG' },
  { name: 'Niue', code: 'NU', nameKey: 'allCountries.NU' },
  { name: 'Norfolk Island', code: 'NF', nameKey: 'allCountries.NF' },
  { name: 'Northern Mariana Islands', code: 'MP', nameKey: 'allCountries.MP' },
  { name: 'Norway', code: 'NO', nameKey: 'allCountries.NO' },
  { name: 'Oman', code: 'OM', nameKey: 'allCountries.OM' },
  { name: 'Pakistan', code: 'PK', nameKey: 'allCountries.PK' },
  { name: 'Palau', code: 'PW', nameKey: 'allCountries.PW' },
  { name: 'Palestinian Territory, Occupied', code: 'PS', nameKey: 'allCountries.PS' },
  { name: 'Panama', code: 'PA', nameKey: 'allCountries.PA' },
  { name: 'Papua New Guinea', code: 'PG', nameKey: 'allCountries.PG' },
  { name: 'Paraguay', code: 'PY', nameKey: 'allCountries.PY' },
  { name: 'Peru', code: 'PE', nameKey: 'allCountries.PE' },
  { name: 'Philippines', code: 'PH', nameKey: 'allCountries.PH' },
  { name: 'Pitcairn', code: 'PN', nameKey: 'allCountries.PN' },
  { name: 'Poland', code: 'PL', nameKey: 'allCountries.PL' },
  { name: 'Portugal', code: 'PT', nameKey: 'allCountries.PT' },
  { name: 'Puerto Rico', code: 'PR', nameKey: 'allCountries.PR' },
  { name: 'Qatar', code: 'QA', nameKey: 'allCountries.QA' },
  { name: 'Reunion', code: 'RE', nameKey: 'allCountries.Re' },
  { name: 'Romania', code: 'RO', nameKey: 'allCountries.RO' },
  { name: 'Russian Federation', code: 'RU', nameKey: 'allCountries.RU' },
  { name: 'RWANDA', code: 'RW', nameKey: 'allCountries.RW' },
  { name: 'Saint Helena', code: 'SH', nameKey: 'allCountries.SH' },
  { name: 'Saint Kitts and Nevis', code: 'KN', nameKey: 'allCountries.KN' },
  { name: 'Saint Lucia', code: 'LC', nameKey: 'allCountries.LC' },
  { name: 'Saint Pierre and Miquelon', code: 'PM', nameKey: 'allCountries.PM' },
  { name: 'Saint Vincent and the Grenadines', code: 'VC', nameKey: 'allCountries.VC' },
  { name: 'Samoa', code: 'WS', nameKey: 'allCountries.WS' },
  { name: 'San Marino', code: 'SM', nameKey: 'allCountries.SM' },
  { name: 'Sao Tome and Principe', code: 'ST', nameKey: 'allCountries.ST' },
  { name: 'Saudi Arabia', code: 'SA', nameKey: 'allCountries.SA' },
  { name: 'Senegal', code: 'SN', nameKey: 'allCountries.SN' },
  { name: 'Serbia and Montenegro', code: 'CS', nameKey: 'allCountries.CS' },
  { name: 'Seychelles', code: 'SC', nameKey: 'allCountries.SC' },
  { name: 'Sierra Leone', code: 'SL', nameKey: 'allCountries.SL' },
  { name: 'Singapore', code: 'SG', nameKey: 'allCountries.SG' },
  { name: 'Slovakia', code: 'SK', nameKey: 'allCountries.SK' },
  { name: 'Slovenia', code: 'SI', nameKey: 'allCountries.SI' },
  { name: 'Solomon Islands', code: 'SB', nameKey: 'allCountries.SB' },
  { name: 'Somalia', code: 'SO', nameKey: 'allCountries.SO' },
  { name: 'South Africa', code: 'ZA', nameKey: 'allCountries.ZA' },
  { name: 'South Georgia and the South Sandwich Islands', code: 'GS', nameKey: 'allCountries.GS' },
  { name: 'Spain', code: 'ES', nameKey: 'allCountries.ES' },
  { name: 'Sri Lanka', code: 'LK', nameKey: 'allCountries.LK' },
  { name: 'Sudan', code: 'SD', nameKey: 'allCountries.SD' },
  { name: 'Suriname', code: 'SR', nameKey: 'allCountries.SR' },
  { name: 'Svalbard and Jan Mayen', code: 'SJ', nameKey: 'allCountries.SJ' },
  { name: 'Swaziland', code: 'SZ', nameKey: 'allCountries.SZ' },
  { name: 'Sweden', code: 'SE', nameKey: 'allCountries.SE' },
  { name: 'Switzerland', code: 'CH', nameKey: 'allCountries.CH' },
  { name: 'Syrian Arab Republic', code: 'SY', nameKey: 'allCountries.SY' },
  { name: 'Taiwan, Province of China', code: 'TW', nameKey: 'allCountries.TW' },
  { name: 'Tajikistan', code: 'TJ', nameKey: 'allCountries.TJ' },
  { name: 'Tanzania, United Republic of', code: 'TZ', nameKey: 'allCountries.TZ' },
  { name: 'Thailand', code: 'TH', nameKey: 'allCountries.TH' },
  { name: 'Timor-Leste', code: 'TL', nameKey: 'allCountries.TL' },
  { name: 'Togo', code: 'TG', nameKey: 'allCountries.TG' },
  { name: 'Tokelau', code: 'TK', nameKey: 'allCountries.TK' },
  { name: 'Tonga', code: 'TO', nameKey: 'allCountries.TO' },
  { name: 'Trinidad and Tobago', code: 'TT', nameKey: 'allCountries.TT' },
  { name: 'Tunisia', code: 'TN', nameKey: 'allCountries.TN' },
  { name: 'Turkey', code: 'TR', nameKey: 'allCountries.TR' },
  { name: 'Turkmenistan', code: 'TM', nameKey: 'allCountries.TM' },
  { name: 'Turks and Caicos Islands', code: 'TC', nameKey: 'allCountries.TC' },
  { name: 'Tuvalu', code: 'TV', nameKey: 'allCountries.TV' },
  { name: 'Uganda', code: 'UG', nameKey: 'allCountries.UG' },
  { name: 'Ukraine', code: 'UA', nameKey: 'allCountries.UA' },
  { name: 'United Arab Emirates', code: 'AE', nameKey: 'allCountries.AE' },
  { name: 'United Kingdom', code: 'GB', nameKey: 'allCountries.GB' },
  { name: 'United States', code: 'US', nameKey: 'allCountries.US' },
  { name: 'United States Minor Outlying Islands', code: 'UM', nameKey: 'allCountries.UM' },
  { name: 'Uruguay', code: 'UY', nameKey: 'allCountries.UY' },
  { name: 'Uzbekistan', code: 'UZ', nameKey: 'allCountries.UZ' },
  { name: 'Vanuatu', code: 'VU', nameKey: 'allCountries.VU' },
  { name: 'Venezuela', code: 'VE', nameKey: 'allCountries.VE' },
  { name: 'Viet Nam', code: 'VN', nameKey: 'allCountries.VN' },
  { name: 'Virgin Islands, British', code: 'VG', nameKey: 'allCountries.VG' },
  { name: 'Virgin Islands, U.S.', code: 'VI', nameKey: 'allCountries.VI' },
  { name: 'Wallis and Futuna', code: 'WF', nameKey: 'allCountries.WF' },
  { name: 'Western Sahara', code: 'EH', nameKey: 'allCountries.EH' },
  { name: 'Yemen', code: 'YE', nameKey: 'allCountries.YE' },
  { name: 'Zambia', code: 'ZM', nameKey: 'allCountries.ZM' },
  { name: 'Zimbabwe', code: 'ZW', nameKey: 'allCountries.ZW' }
];

export const useCountries = ({ search }) => {
  const countries = useMemo(
    () =>
      search?.length > 0
        ? ALL_COUNTRIES?.filter(
            (c) =>
              c.name?.toLowerCase?.()?.includes(search?.toLowerCase?.()) ||
              c.code?.toLowerCase?.()?.includes(search?.toLowerCase?.())
          )
        : ALL_COUNTRIES,
    [search]
  );
  return { countries };
};
